<template>
  <v-card>
    <v-card-title class="modal-top-success-text">{{ data.title }}</v-card-title>
    
    <v-card-text>
     <div class="modal-top-success-text">
                   <span class="span-bold">   {{ data.message }} </span>
                </div>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      
                   
             
      <!-- <v-btn color="primary" @click="handlePurchase">
        Purchase
      </v-btn> -->
       <div class="modal-top-failed-btm-block">
      <div class="btn-center-align">
                   
                    <v-btn @click="onClose({ status: false })" class="right-btn cust-btn" color="primary">Cancel</v-btn>
                     <v-btn
                        class="right-btn cust-btn resend-code-btn"
                        color="primary"
                        @click="handlePurchase"
                    >Purchase</v-btn>
                </div>
                   </div>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "PurchaseModal",
  props: {
    data: Object,
    onClose: Function
  },
  methods: {
    handlePurchase() {
      if (this.data.onPurchase) {
        this.data.onPurchase();
      }
      this.onClose({ status: false });
    }
  }
};
</script>